import { Layout } from "antd";
import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import StickyBox from "react-sticky-box";
import {
  Bets,
  BetSlip,
  EventsSports,
  Images,
  MenuTree,
  Screen,
  ScreenTitle,
  SportTypes,
  Search,
  Banner,
  OnScreenWrapper,
} from "../../components";
import CategoriesMenu from "../../components/layout/CategoriesMenu";
import { init } from "../../redux/actions/appActions";
import { initSportTypes } from '../../redux/actions/sportTypesActions';
import {
  loadAllBetTypes,
  setEvent,
} from "../../redux/actions/sportEventsActions";
import { useMediaQuery } from "react-responsive";
import SiderBanner from "../../components/layout/SiderBanner";
import { changeFeed } from "../../redux/actions/appActions";

const IsMiddleScreenAndMobile = ({ children }) => {
  const isDesktop = useMediaQuery({ maxWidth: 1100 });
  return isDesktop ? children : null;
};
const IsDesktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1100 });
  return isDesktop ? children : null;
};

const { Sider, Content } = Layout;

class Sport extends React.Component {

  async componentDidMount() {
    const { initSportTypes, changeFeed } = this.props;
    initSportTypes();
    changeFeed('6', 'sport');

  }
  render() {
    const { match, mainTournamentImage, showMainTournament } = this.props;
    return (
      <Screen {...this.props}>
        <SportTypes {...this.props} />
        <Layout className="sport mtop-10">
          <Layout className="layout-inner">
            <Content>
              <Banner
                sportType={this.props.match.params.sportName}
                {...this.props}
              />
              <IsMiddleScreenAndMobile>
                {showMainTournament && (
                  <div className="world-cup-image-container">
                    <img
                      className="world-cup-banner"
                      onClick={() => {
                        this.props.history.push("/worldcup/1");
                      }}
                      src={mainTournamentImage}
                      alt="world-cup"
                    />
                    <img className="hand-image" src={Images.Hand} alt="hand" />
                    <img
                      className="shine-image"
                      src={Images.Shine}
                      alt="shine"
                    />
                  </div>
                )}{" "}
              </IsMiddleScreenAndMobile>
              <CategoriesMenu />
              <Layout>
                <Sider width={220} className="sider-left">
                  {/* <StickyBox offsetTop={150} offsetBottom={10}>
                  </StickyBox> */}
                  {/* <Search {...this.props} /> */}
                  <div style={{ position: "sticky", top: "200px" }}>
                    <MenuTree {...this.props} />
                  </div>
                </Sider>

                <Content className="content">
                  {/* <ScreenTitle
                    {...this.props}
                    title={match.params.sportName || `Sports Betting`}
                    imageIcon={Images.Icon_Soccer}
                    imageTheme={Images.Strip_Soccer}
                  /> */}

                  <Route
                    exact
                    path="/sport/:feed/:sport/:sportName"
                    component={Bets.TopBets}
                  />
                  <Route
                    exact
                    path="/sport/:feed/:sport/:sportName/today/:day"
                    component={Bets.Today}
                  />
                  <Route
                    exact
                    path="/sport/:feed/:sport/:sportName/events/:section/:country/:countryName/:tournament/:tournamentName/:categoryCode?/:tournamentUId?/:isFavorite?"
                    component={EventsSports}
                  />
                  <Route
                    exact
                    path="/sport/:feed/:sport/:sportName/event/:country/:tournament/:eventId"
                    component={Bets.DrillDown}
                  />
                </Content>
              </Layout>
            </Content>
            <Sider width={350} className="sider-right">
              <IsDesktop>
                {showMainTournament && (
                  <div className="world-cup-image-container-desktop">
                    <img
                      className="world-cup-banner"
                      onClick={() => {
                        this.props.history.push("/worldcup/1");
                      }}
                      src={mainTournamentImage}
                      alt="world-cup"
                    />
                    <img className="hand-image" src={Images.Hand} alt="hand" />
                    <img
                      className="shine-image"
                      src={Images.Shine}
                      alt="shine"
                    />
                  </div>
                )}{" "}
              </IsDesktop>
              <div style={{ position: "sticky", top: "130px" }}>
                <BetSlip {...this.props} />
                <OnScreenWrapper
                  styleFunction={(bool) => ({
                    width: "100%",
                    height: bool ? "fit-content" : 154,
                  })}
                >
                  <SiderBanner />
                </OnScreenWrapper>
              </div>
            </Sider>
          </Layout>
        </Layout>
      </Screen>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    connecting: state.signalr.staticConnecting,
    connected: state.signalr.staticConnected,
    feedId: state.app.feedId,
    feedName: state.app.feedName,
    sportData: state.sportTypes.sportData,
    tournamentData: state.categories.tournamentData,
    mainTournamentImage: state.general.configuration.mainTournamentImage,
    showMainTournament: state.general.configuration.showMainTournament,

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loadAllBetTypes: () => {
      dispatch(loadAllBetTypes());
    },
    setEvent: (item) => {
      dispatch(setEvent(item));
    },
    init: () => {
      dispatch(init());
    },
    initSportTypes: () =>
      dispatch(initSportTypes()),
    changeFeed: (feedId, feedName) => dispatch(changeFeed(feedId, feedName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sport);
